var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.507 11.016c.324-1.398-.1-3.001-1.093-4.066-1.067-1.144-4.316-3.714-8.978.212-.144.097-.29.197-.436.302a6.5 6.5 0 1 1 8.525 6.215c1.544-1.202 1.928-2.429 1.982-2.663zM7.46 14a6.501 6.501 0 0 1-6.424-5.815l.137-.126c1.53-1.407 3.23-2.136 4.871-2.172 1.52-.033 2.906.537 3.873 1.574.879.942 1.262 2.3.977 3.528-.316 1.367-1.4 2.434-3.19 2.932l-.247.068.003.011z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F33A40",
    fillRule: "nonzero",
    d: "M1.198 8.036c2.624-2.475 5.988-2.822 8.273-1.04 2.671 2.09 1.748 6.058-1.635 6.914l-.187.043-.212.046a6.464 6.464 0 0 1-1.468-.182c.533-.078 1.067-.154 1.59-.29 3.178-.677 4.07-4.291 1.644-6.189-2.05-1.599-5.074-1.322-7.517.849l-.197.18-.372.38a4.035 4.035 0 0 1-.083-.564l.164-.147z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F33A40",
    fillRule: "nonzero",
    d: "M1.022 6.94c3.052-2.294 5.932-3.12 8.76-1.045 2.894 2.31 2.666 5.3 1.014 7.21a5.29 5.29 0 0 1-1.278.57l.29-.235c2.024-1.64 2.681-4.798-.29-7.2-2.555-1.874-5.288-1.122-8.122.948L1 7.464c.003-.167.008-.336.022-.524zm12.934-.331c-.084-4.178-4.1-5.421-4.644-5.356 0 0 3.858 1.512 4.644 5.356z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.b603e673fa508882589a1b09cdd3e8ea.svg";
export { ForwardRef as ReactComponent };